'use es6';

import React from 'react';
import { Route, Redirect, IndexRedirect } from 'react-router';
import Loadable from 'UIComponents/decorators/Loadable';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import App from './containers/AppContainer';
import Directory from './containers/DirectoryContainer';
import GoodDetails from './containers/GoodDetailsContainer';
import GoodDetailsPreview from './containers/GoodDetailsPreviewContainer';
import GoodDetailsReview from './containers/GoodDetailsReviewContainer';
import * as UrlPathParams from './constants/UrlPathParams';
import { managePurchasesPrefetcher } from './prefetchers/managePurchasesPrefetcher';
var AsyncManagePurchases = Loadable({
  loader: managePurchasesPrefetcher,
  LoadingComponent: function LoadingComponent(_ref) {
    var pastDelay = _ref.pastDelay;
    return pastDelay ? React.createElement(UILoadingSpinner, null) : null;
  },
  ErrorComponent: function ErrorComponent() {
    return React.createElement(UIErrorMessage, null);
  }
});
export default function () {
  return React.createElement(Route, {
    path: "/",
    component: App
  }, React.createElement(IndexRedirect, {
    to: UrlPathParams.DIRECTORY_PAGE_PATH
  }), React.createElement(Route, {
    path: UrlPathParams.DIRECTORY_PAGE_PATH,
    component: Directory
  }), React.createElement(Route, {
    path: UrlPathParams.GOOD_DETAILS_PREVIEW_PATH,
    component: GoodDetailsPreview
  }), React.createElement(Route, {
    path: UrlPathParams.GOOD_DETAILS_REVIEW_PATH,
    component: GoodDetailsReview
  }), React.createElement(Route, {
    path: UrlPathParams.GOOD_DETAILS_PATH,
    component: GoodDetails
  }), React.createElement(Route, {
    path: UrlPathParams.MANAGE_PURCHASES_PATH,
    component: AsyncManagePurchases
  }), React.createElement(Redirect, {
    from: UrlPathParams.GOOD_DETAILS_DEMO_PATH,
    to: UrlPathParams.GOOD_DETAILS_PATH
  }), React.createElement(Redirect, {
    from: "*",
    to: UrlPathParams.DIRECTORY_PAGE_PATH
  }));
}